var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"envelope-list"},_vm._l((_vm.envelopes),function(envelope){return _c('envelope-list-item',{key:envelope.id,attrs:{"envelope":envelope}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }